// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/thumbnailFileUploadService', () => import('js/thumbnailFileUploadService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "description": {
            "displayName": "{{i18n.descriptionLabel}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": "",
            "numberOfLines": 3
        },
        "image": {
            "displayName": "{{i18n.imageLabel}}",
            "type": "STRING"
        },
        "isThumbnailSelected": false
    },
    "lifecycleHooks": {
        "onMount": "loadLibraryDetails",
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.libraryid"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "loadLibraryList": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "loadLibraryList"
                    }
                ]
            }
        },
        "loadLibraryDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query getLibrary( $libraryId: String) {getLibrary( libraryId: $libraryId) }",
                        "variables": {
                            "libraryId": "{{props.libraryid}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "loadedLibraryDetails": "data.data.getLibrary.libraryObjs[0]"
            },
            "events": {
                "failure": [
                    {
                        "name": "loadLibraryDetailsFailure",
                        "eventData": {
                            "eventData": "{{loadedLibraryDetails}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "loadLibraryDetailsSuccess",
                        "eventData": {
                            "eventName": "loadLibraryDetailsSuccess",
                            "eventData": "{{loadedLibraryDetails}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateLibrary": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "mutation UpdateLibrary($libraryId: String, $updateLibraryInput: UpdateLibraryInput) {updateLibrary( libraryId: $libraryId, updateLibraryInput: $updateLibraryInput )}",
                        "variables": {
                            "libraryId": "{{props.libraryid}}",
                            "updateLibraryInput": {
                                "name": "{{data.name.dbValue}}",
                                "description": "{{data.description.dbValue}}",
                                "updateThumbnail": "{{data.isThumbnailSelected}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "updatedLibrary": "data.data.updateLibrary",
                "accUrl": "data.data.updateLibrary.url",
                "error": "data.data.updateLibrary",
                "output": "data.data.updateLibrary.output"
            },
            "events": {
                "failure": [
                    {
                        "name": "updateLibraryFailure",
                        "eventData": {
                            "eventData": "{{updatedLibrary}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desUpdateLibrarySuccess",
                        "eventData": {
                            "eventData": "{{updatedLibrary}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesUpdateLibrarySuccessMsg",
                        "condition": "output.success === true"
                    },
                    {
                        "message": "displayDesUpdateLibraryFailureMsg",
                        "condition": "output.success === false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateloadedLibraryDetails": {
            "actionType": "JSFunction",
            "method": "getSelectedLibraryDetails",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "updateSelectedFileInfoAction": {
            "actionType": "JSFunction",
            "method": "getSelectedFileInfo",
            "inputData": {
                "fileName": "{{parameters.fileName}}",
                "formData": "{{parameters.formData}}",
                "parameters": "{{parameters}}"
            },
            "outputData": {
                "fileInputForms": "fileInputForms",
                "fileNames": "fileNames",
                "isFileValid": "isFileValid",
                "fileType": "fileType"
            },
            "events": {
                "success": [
                    {
                        "name": "fileSelectionSuccess",
                        "eventData": {
                            "eventData": "{{isFileValid}}"
                        }
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "uploadFileToServer": {
            "actionType": "JSFunctionAsync",
            "method": "sendDssFileToUpload",
            "inputData": {
                "accsessionid": "{{props.accsessionid}}",
                "thumbnailTicket": "{{data.updatedLibrary.output.data.thumbnailUploadTicket}}",
                "formData": "{{data.fileInputForms}}",
                "fileType": "{{data.fileType}}",
                "accUrl": "{{data.accUrl}}"
            },
            "events": {
                "success": [
                    {
                        "name": "uploadfilesuccess"
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "selectThumbnail": {
            "actionType": "JSFunction",
            "method": "updateThumbnailBool",
            "inputData": {
                "vmo": "{{data}}",
                "validFile": "{{parameters.eventData}}"
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "performBatchActionOnUpdateLibrary": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "uploadFileToServer",
                    "condition": "data.isThumbnailSelected === true"
                },
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "loadLibraryList"
                }
            ]
        }
    },
    "conditions": {
        "enableUpdateButton": {
            "expression": "data.name.dbValue"
        }
    },
    "onEvent": [
        {
            "eventId": "desUpdateLibrarySuccess",
            "action": "performBatchActionOnUpdateLibrary",
            "inputArgs": {
                "eventName": "desUpdateLibrarySuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "updateLibraryFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "updateLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "loadLibraryDetailsSuccess",
            "action": "updateloadedLibraryDetails",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "invalidFileSelected",
            "message": "invalidFileError"
        },
        {
            "eventId": "fileSelectionSuccess",
            "action": "selectThumbnail",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "messages": {
        "displayDesUpdateLibrarySuccessMsg": {
            "messageType": "INFO",
            "messageText": "\"{0}\" updated successfully",
            "messageTextParams": [
                "{{data.name.dbValue}}"
            ]
        },
        "displayDesLoadedLibrarySuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.loadLibrarySuccessMsg}}"
        },
        "displayDesUpdateLibraryFailureMsg": {
            "messageType": "ERROR",
            "messageText": "{{i18n.updateLibraryFailedMsg}}"
        }
    },
    "i18n": {
        "name": [
            "libraryMessages"
        ],
        "descriptionLabel": [
            "libraryMessages"
        ],
        "imageLabel": [
            "libraryMessages"
        ],
        "upadeButton": [
            "libraryMessages"
        ],
        "updateLibrarySuccessMsg": [
            "libraryMessages"
        ],
        "wasUpdated": [
            "libraryMessages"
        ],
        "loadLibrarySuccessMsg": [
            "libraryMessages"
        ],
        "invalidFileError": [
            "libraryMessages"
        ],
        "cancelText": [
            "libraryMessages"
        ],
        "updateLibraryFailedMsg": [
            "libraryMessages"
        ]
    },
    "_viewModelId": "DesUpdateLibrary",
    "_uniqueViewModelId": "DesUpdateLibrary",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-textbox prop="data.name"></aw-textbox>
        <aw-break></aw-break>
        <aw-textarea prop="data.description"></aw-textarea>
        <aw-break></aw-break>
        <aw-label prop="data.image"></aw-label>
        <aw-file-upload type-filter=".png, .gif, .jpg, .jpeg" file-change-action="updateSelectedFileInfoAction">
        </aw-file-upload>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button class='small' action='updateLibrary' button-type='accent-high-contrast' size='stretched'
            enable-when="conditions.enableUpdateButton">{{i18n.upadeButton}}</aw-button>
        <aw-break></aw-break>
    </aw-panel-footer>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwTextbox {...getField("data.name", fields, $index, null, null )}>
            </AwTextbox>
            <AwBreak>
            </AwBreak>
            <AwTextarea {...getField("data.description", fields, $index, null, null )}>
            </AwTextarea>
            <AwBreak>
            </AwBreak>
            <AwLabel {...getField("data.image", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} typeFilter=".png, .gif, .jpg, .jpeg" fileChangeAction={actions.updateSelectedFileInfoAction}>
            </AwFileUpload>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen className="small" action={actions.updateLibrary} buttonType="accent-high-contrast" size="stretched" enableWhen={AwParseService.instance( "conditions.enableUpdateButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.upadeButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
            <AwBreak>
            </AwBreak>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;